import { EOrganisationCategory } from 'constants/OrganisationCategory';
import { EDictionaryPrefixTypesUniqueId } from 'helpers/dictionary';

// Mapping between Legal Entity Group checkboxes and their corresponding API field values.
// Civilian, Military, and Police checkboxes send to both prefixGroupIds and organisationCategoryIds.
// State checkbox only sends to organisationCategoryIds.
export const LEGAL_ENTITY_GROUP_MAPPING: Record<
  string,
  {
    prefixGroupId: string | null;
    organisationCategoryId: string;
  }
> = {
  [EDictionaryPrefixTypesUniqueId.civilianPrefix]: {
    prefixGroupId: EDictionaryPrefixTypesUniqueId.civilianPrefix,
    organisationCategoryId: EOrganisationCategory.civilian,
  },
  [EDictionaryPrefixTypesUniqueId.militaryPrefix]: {
    prefixGroupId: EDictionaryPrefixTypesUniqueId.militaryPrefix,
    organisationCategoryId: EOrganisationCategory.military,
  },
  [EDictionaryPrefixTypesUniqueId.policePrefix]: {
    prefixGroupId: EDictionaryPrefixTypesUniqueId.policePrefix,
    organisationCategoryId: EOrganisationCategory.police,
  },
  [EOrganisationCategory.state]: {
    prefixGroupId: null,
    organisationCategoryId: EOrganisationCategory.state,
  },
};
